export default {
    gray: {
        '--C_129': '#e2e2e2',
        '--C_171': '#D3D3D3',
        '--C_174': '#f3f3f3',
        '--C_175': '#F8F8F8 0, #eeeeee 100%',
        '--C_176': '#F8F8F8 0, #eeeeee 100%',
        '--C_177': '#F8F8F8 0, #eeeeee 100%',
        '--C_178': '#F8F8F8 0, #eeeeee 100%',
        '--C_180': 'startColorstr=#F8F8F8, endColorstr=#eeeeee, GradientType=0',
        '--C_181': '#575765',
        '--C_184': '#ffffff',
        '--C_185': '#000000',
        '--C_191': '#575765',
        '--C_196': '#D3D3D3',
        '--C_198': '#fafafa',
        '--C_199': '#000000',
        '--C_357': '#ffffff',
        '--C_358': '#D3D3D3',
        '--C_361': '#f3f3f3',
        '--C_365': '#0092DC',
        '--C_368': '#fff',
        '--C_371': '#f3f3f3',
        '--C_374': '#ffffff',
        '--C_378': '#D3D3D3',
        '--C_390': '#f3f3f3',
        '--C_393': '#ffffff',
        '--C_397': '#D3D3D3',
        '--C_409': '#f3f3f3',
        '--C_412': '#ffffff',
        '--C_416': '#D3D3D3',
        '--C_481': '#ccc',
        '--C_482': '#cccccc',
        '--C_483': '#cccccc',
        '--C_484': '#cccccc',
        '--C_489': '#D3D3D3',
        '--C_492': '#f3f3f3',
        '--C_493': '#F8F8F8 0, #eeeeee 20%',
        '--C_494': '#F8F8F8 0, #eeeeee 20%',
        '--C_495': '#F8F8F8 0, #eeeeee 20%',
        '--C_496': '#F8F8F8 0, #eeeeee 20%',
        '--C_498': 'startColorstr=#F8F8F8, endColorstr=#eeeeee, GradientType=0',
        '--C_501': '#D3D3D3',
        '--C_505': '#ccc',
        '--C_508': '#D3D3D3',
        '--C_616': '#ccc',
        '--C_617': '#fff',
        '--C_631': '#fafafa',
        '--C_636': '#D3D3D3 #D3D3D3 #ddd #D3D3D3',
        '--C_639': '#ddd #D3D3D3 #D3D3D3 #D3D3D3',
        '--C_644': '#fafafa',
        '--C_654': '#ccc',
        '--C_802': '#444',
        '--C_803': '#fafafa',
        '--C_805': '#bbb',
        '--C_806': '#ffffff 0, #eeeeee 100%',
        '--C_807': '#ffffff 0, #eeeeee 100%',
        '--C_808': '#ffffff 0, #eeeeee 100%',
        '--C_809': '#ffffff 0, #eeeeee 100%',
        '--C_811': 'startColorstr=#ffffff, endColorstr=#eeeeee, GradientType=0',
        '--C_817': '#e2e2e2',
        '--C_818': '#000000',
        '--C_819': '#ccc',
        '--C_829': '#ccc',
        '--C_833': '#e2e2e2',
        '--C_834': '#000000',
        '--C_835': '#ccc',
        '--C_844': '#fafafa',
        '--C_845': '#444',
        '--C_846': '#ffffff 0, #eeeeee 100%',
        '--C_847': '#ffffff 0, #eeeeee 100%',
        '--C_848': '#ffffff 0, #eeeeee 100%',
        '--C_849': '#ffffff 0, #eeeeee 100%',
        '--C_851': 'startColorstr=#ffffff, endColorstr=#eeeeee, GradientType=0',
        '--C_864': '#ddd',
        '--C_869': '#ddd',
        '--C_873': '#D3D3D3',
        '--C_1014': '#bababa',
        '--C_1015': '#D3D3D3',
        '--C_1016': '#D3D3D3',
        '--C_1017': '#D3D3D3',
        '--C_1091': '#ffffff',
        '--C_1094': '#f3f3f3',
        '--C_1097': '#e2e2e2',
        '--C_1100': '#e2e2e2',
        '--C_1131': '#e2e2e2',
        '--C_1132': '#000000',
        '--C_1135': '#0092DC',
        '--C_1136': '#fff',
        '--C_1162': '#e2e2e2',
        '--C_1163': '#000000',
        '--C_1319': '#bfbfbf',
        '--C_1322': '#efefef',
        '--C_1325': '#efefef',
        '--C_1328': '#efefef',
        '--C_1331': '#efefef',
        '--C_1334': '#f3f3f3',
        '--C_1337': '#f3f3f3',
        '--C_1654': '#f3f3f3',
        '--C_1657': '#f3f3f3',
        '--C_1663': '#e2e2e2',
        '--C_1664': '#000000',
        '--C_1668': '#ffffff',
        '--C_1669': '#575765',
        '--C_1670': '#F8F8F8 0, #ffffff 100%',
        '--C_1671': '#F8F8F8 0, #ffffff 100%',
        '--C_1672': '#F8F8F8 0, #ffffff 100%',
        '--C_1673': '#F8F8F8 0, #ffffff 100%',
        '--C_1675': 'startColorstr=#F8F8F8, endColorstr=#ffffff, GradientType=0',
             '--C_1678': '#ffffff 0, #F8F8F8 100%',
        '--C_1679': '#ffffff 0, #F8F8F8 100%',
        '--C_1680': '#ffffff 0, #F8F8F8 100%',
        '--C_1681': '#ffffff 0, #F8F8F8 100%',
        '--C_1683': 'startColorstr=#ffffff, endColorstr=#F8F8F8, GradientType=0',
        '--C_1686': '#F8F8F8 0, #ffffff 100%',
        '--C_1687': '#F8F8F8 0, #ffffff 100%',
        '--C_1688': '#F8F8F8 0, #ffffff 100%',
        '--C_1689': '#F8F8F8 0, #ffffff 100%',
        '--C_1691': 'startColorstr=#F8F8F8, endColorstr=#ffffff, GradientType=1',
        '--C_1694': '#ffffff 0, #F8F8F8 100%',
        '--C_1695': '#ffffff 0, #F8F8F8 100%',
        '--C_1696': '#ffffff 0, #F8F8F8 100%',
        '--C_1697': '#ffffff 0, #F8F8F8 100%',
        '--C_1699': 'startColorstr=#ffffff, endColorstr=#F8F8F8, GradientType=1',
        '--C_1702': '#575765',
        '--C_1703': '#f3f3f3',
        '--C_1704': '#F8F8F8 0, #eeeeee 100%',
        '--C_1705': '#F8F8F8 0, #eeeeee 100%',
        '--C_1706': '#F8F8F8 0, #eeeeee 100%',
        '--C_1707': '#F8F8F8 0, #eeeeee 100%',
        '--C_1709': 'startColorstr=#F8F8F8, endColorstr=#eeeeee, GradientType=0',
        '--C_1713': '#f3f3f3',
        '--C_1729': '#D3D3D3',
        '--C_1734': '#e2e2e2',
        '--C_1737': '#ffffff',
        '--C_1740': '#ffffff',
        '--C_1743': '#ffffff',
        '--C_1746': '#ffffff',
        '--C_1749': '#0092DC',
        '--C_1750': '#fff',
        '--C_1752': '#D3D3D3',
        '--C_1817': '#ccc',
        '--C_1818': '#fff',
        '--C_1946': '#D3D3D3',
        '--C_1978': '#ffffff',
        '--C_1982': '#fafafa',
        '--C_1983': '#fdfdfd 0, #f5f5f5 100%',
        '--C_1984': '#fdfdfd 0, #f5f5f5 100%',
        '--C_1985': '#fdfdfd 0, #f5f5f5 100%',
        '--C_1986': '#fdfdfd 0, #f5f5f5 100%',
        '--C_1988': 'startColorstr=#fdfdfd, endColorstr=#f5f5f5, GradientType=0',
        '--C_1991': '#000000',
        '--C_1994': '#bfbfbf',
        '--C_1997': '#ccc',
        '--C_2000': '#D3D3D3',
        '--C_2004': '#fafafa',
        '--C_2010': '#ddd',
        '--C_2015': '#ccc',
        '--C_2020': '#000000',
        '--C_2024': '#fafafa',
        '--C_2028': '#e2e2e2',
        '--C_2029': '#000000',
        '--C_2033': '#0092DC',
        '--C_2034': '#fff',
        '--C_2051': '#0070a9',
        '--C_2054': '#0070a9',
        '--C_2072': '#ddd',
        '--C_2075': '#f3f3f3',
        '--C_2078': '#ddd',
        '--C_2084': '#f3f3f3',
        '--C_2095': '#fafafa',
        '--C_2098': '#ccc',
        '--C_2135': '#000000',
        '--C_2172': '#ccc',
        '--C_2175': '#e2e2e2',
        '--C_2176': '#000000',
        '--C_2195': '#ccc',
        '--C_2196': '#fff',
        '--C_2256': '#D3D3D3',
        '--C_2415': '#4d4d4d',
        '--C_2418': '#000000',
        '--C_2430': '#D3D3D3',
        '--C_2433': '#D3D3D3',
        '--C_2436': '#f3f3f3',
        '--C_2440': '#ffffff',
        '--C_2443': '#fafafa',
        '--C_2449': '#e2e2e2',
        '--C_2450': '#000000',
        '--C_2453': '#ccc',
        '--C_2457': '#0092DC',
        '--C_2458': '#fff',
        '--C_2459': '#0070a9',
        '--C_2463': '#f3f3f3',
        '--C_2502': '#fafafa',
        '--C_2505': '#444',
        '--C_2521': '#f3f3f3',
        '--C_2533': '#444',
        '--C_2535': '#f3f3f3',
        '--C_2578': '#e2e2e2',
        '--C_2590': '#e2e2e2',
        '--C_2600': '#f3f3f3',
        '--C_2609': '#f3f3f3',
        '--C_2613': '#f3f3f3',
        '--C_2643': '#D3D3D3',
        '--C_2646': '#000000',
        '--C_2651': '#0092DC',
        '--C_2652': '#fff',
        '--C_2708': '#f3f3f3',
        '--C_2807': '#D3D3D3',
        '--C_2808': '#f3f3f3',
        '--C_2811': '#D3D3D3',
        '--C_2814': '#000000',
        '--C_2896': '#ccc',
        '--C_2897': '#cccccc',
        '--C_2898': '#cccccc',
        '--C_2899': '#cccccc',
        '--C_2906': '#ccc',
        '--C_2907': '#fff',
        '--C_2910': '#ccc',
        '--C_2911': '#fff',
        '--C_2914': '#f3f3f3',
        '--C_2915': '#D3D3D3',
        '--C_2916': '#444',
        '--C_2919': '#ffffff',
        '--C_2923': '#f3f3f3',
        '--C_2926': '#ccc',
        '--C_2927': '#000000',
        '--C_2928': '#e2e2e2',
        '--C_2933': '#444',
        '--C_2948': '#e2e2e2',
        '--C_2949': '#000000',
        '--C_2950': '#ccc',
        '--C_3002': '#bfbfbf',
        '--C_3025': '#ccc',
        '--C_3026': '#e2e2e2',
        '--C_3027': '#000000',
        '--C_3038': '#bfbfbf',
        '--C_3080': '#D3D3D3',
        '--C_3086': '#ccc',
        '--C_3251': '#D3D3D3',
        '--C_3264': '#ffffff',
        '--C_3265': '#000000',
        '--C_3266': '#D3D3D3',
        '--C_3269': '#e2e2e2',
        '--C_3270': '#000000',
        '--C_3273': '#0092DC',
        '--C_3274': '#D3D3D3',
        '--C_3369': '#ffffff',
        '--C_3370': '#D3D3D3',
        '--C_3371': '#000000',
        '--C_3374': '#D3D3D3',
        '--C_3377': '#ffffff',
        '--C_3380': '#D3D3D3',
        '--C_3383': '#ffffff',
        '--C_3386': '#D3D3D3',
        '--C_3389': '#ffffff',
        '--C_3392': '#D3D3D3',
        '--C_3395': '#ffffff',
        '--C_3405': '#bbb',
        '--C_3406': '#bbb',
        '--C_3431': '#0092DC',
        '--C_3432': '#fff',
        '--C_3435': '#ffffff',
        '--C_3436': '#000000',
        '--C_3454': '#ffffff',
        '--C_3455': '#000000',
        '--C_3456': '#bbb',
        '--C_3457': '#bbb',
        '--C_3458': '#bbb',
        '--C_3459': '#bbb',
        '--C_3475': '#bbb',
        '--C_3476': '#bbb',
        '--C_3477': '#bbb',
        '--C_3482': '#0070a9',
        '--C_3491': '#0070a9',
        '--C_3507': '#0070a9',
        '--C_3514': '#0070a9',
        '--C_3549': '#575765',
        '--C_3554': '#575765',
        '--C_3557': '#e2e2e2',
        '--C_3558': '#575765',
        '--C_3561': '#e2e2e2',
        '--C_3562': '#575765',
        '--C_3565': '#0070a9',
        '--C_3566': '#fff',
        '--C_3567': '#0092DC',
        '--C_3619': '#f3f3f3',
        '--C_3620': '#575765',
        '--C_3640': '#0070a9',
        '--C_3641': '#fff',
        '--C_3654': '#0070a9',
        '--C_3661': '#0070a9',
        '--C_3665': '#fff',
        '--C_3675': '#0070a9'
    }
}